// extracted by mini-css-extract-plugin
module.exports = {"RetailerOrdersList":"RetailerOrdersList_RetailerOrdersList__2zE-z"};